<div class="cerrix-paginator">
    <div class="space"></div>
    <div class="pages">
        @if (currentPage !== 1) {
            <cerrix-icon-button [disabled]="!length" (click)="onLeftRight(-1)"
                ><mat-icon fontSet="material-symbols-outlined"
                    >chevron_left</mat-icon
                ></cerrix-icon-button
            >

            <div matRipple class="page-item" (click)="onPageSelection(1)">1</div>
        }
        @if (currentPage > 2) {
            <div class="space-item">...</div>
        }

        <div matRipple class="page-item current-page">
            {{ currentPage }}
        </div>

        @if (currentPage < lastPage - 1) {
            <div class="space-item">...</div>
        }
        @if (currentPage !== lastPage) {
            <div matRipple class="page-item" (click)="onPageSelection(lastPage)">
                {{ lastPage }}
            </div>

            <cerrix-icon-button [disabled]="!length" (click)="onLeftRight(1)"
                ><mat-icon fontSet="material-symbols-outlined"
                    >chevron_right</mat-icon
                ></cerrix-icon-button
            >
        }
    </div>
    <div class="text">{{ message }}</div>
</div>
